<template>
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
        <div class="text-center">
            <h1 class="display-1 fw-bold text-primary mb-0">404</h1>
            <h2 class="h4 fw-semibold mb-4 text-muted">Página no encontrada</h2>
            <p class="text-muted mb-5 px-3">
                Lo sentimos, la página que buscas no existe o ha sido movida.
            </p>
            <RouterLink to="/" class="btn btn-primary px-4 shadow-sm">
                <i class="bi bi-house-door me-2" />
                Volver al inicio
            </RouterLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePageHeader } from '@/composables/usePageHeader'
import { useBreadcrumbs } from '@/composables/useBreadcrumbs'

usePageHeader('Error 404')
useBreadcrumbs([{ label: 'Error 404' }])
</script>
